module.exports = __webpack_public_path__ + "static/img/barra_5.71e8ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_5.png
// module id = fmBi
// module chunks = 0